import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
export const Dialog = props => {
    var _a;
    let footer = null;
    const ref = useRef(null);
    useEffect(() => {
        var _a, _b;
        if (props.isOpen) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.showModal();
        }
        else {
            (_b = ref.current) === null || _b === void 0 ? void 0 : _b.close();
        }
    }, [props.isOpen]);
    if (props.footer) {
        footer = (_jsx("div", { className: "modaldialogfooter modal-footer", children: props.footer }));
    }
    else if (props.footerleft || props.footerright) {
        footer = (_jsxs("div", { className: "modaldialogfooter", style: { display: 'flex' }, children: [_jsx("div", { children: props.footerleft }), _jsx("div", { style: { marginLeft: 'auto' }, children: props.footerright })] }));
    }
    // we should add closedby="any" to dialog, but eslint-plugin-react complain and it has no
    // new releases
    return createPortal(_jsxs("dialog", { ref: ref, className: "modaldialog", onCancel: () => props.close(), children: [_jsxs("div", { className: "modaldialogheader", children: [_jsx("div", { className: "title", children: props.title }), _jsx("button", { type: "button", className: "close", onClick: props.close, children: _jsx("span", { "aria-label": "Close", children: "\u00D7" }) })] }), _jsx("div", { className: "modaldialogbody", children: props.children }), footer] }), (_a = document.getElementById('root')) !== null && _a !== void 0 ? _a : document.body);
};
